import { BaseContainerModel } from '../../base-container.model';
import { bl_cms_activity_category_hdr_RowClass } from '../../../dbschema';

export class CmsActivityCategoryContainerModel extends BaseContainerModel {
    bl_cms_activity_category_hdr: bl_cms_activity_category_hdr_RowClass = new bl_cms_activity_category_hdr_RowClass();
}